<script>
import { mapGetters } from 'vuex';
import { isImminent, isEnded } from '../../utils/Time';
import FormGuideEventHeaderDesktop from './FormGuideEventHeaderDesktop.vue';
import FormGuideEventHeaderMobile from './FormGuideEventHeaderMobile.vue';
export default {
  name: 'FormGuideEventHeader',
  components: {
    FormGuideEventHeaderDesktop,
    FormGuideEventHeaderMobile,
  },
  props: {
    eventId: {
      type: String,
      default: null,
    },
    meetingName: {
      type: String,
      default: null,
    },
    slug: {
      type: String,
      default: null,
    },
    eventNumber: {
      type: String,
      default: null,
    },
    raceType: {
      type: String,
      default: 'horse',
      validator: function(value) {
        return ['harness', 'horse', 'greyhound'].indexOf(value) !== -1;
      },
    },
  },
  data() {
    return {
      viewportWidth: window.innerWidth,
    };
  },
  computed: {
    ...mapGetters({
      eventData: 'FormGuideEventHeader/getEventData',
    }),
    isMobile() {
      return this.viewportWidth < 768;
    },
    startTime() {
      return this.eventData ? this.eventData.start_time : '';
    },
    eventName() {
      return this.eventData ? this.eventData.name : '';
    },
    localStartTime() {
      return this.eventData ? this.eventData.start_time : '';
    },
    isResulted() {
      return this.eventData ? this.eventData.is_resulted === 1 : false;
    },
    // is within an hour of starting
    isImminent() {
      return isImminent(this.startTime);
    },
    // start time is in the past
    isEnded() {
      return isEnded(this.startTime);
    },
  },
  mounted() {
    const { eventId, setWindowWidth, meetingName, raceType, slug, eventNumber } = this;
    // add listener to handle page resize
    window.addEventListener('resize', setWindowWidth);
    setWindowWidth();

    // fetch event API
    if (eventId) {
      this.$store.dispatch('FormGuideEventHeader/fetchEventData', { eventId, meetingName });
    } else if (slug && eventNumber) {
      this.$store.dispatch('FormGuideEventHeader/fetchEventBySlug', { slug, eventNumber });
    }
    // set race type
    this.$store.dispatch('FormGuideEventHeader/setRaceType', raceType);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setWindowWidth);
  },
  methods: {
    setWindowWidth() {
      this.viewportWidth = window.innerWidth;
    },
  },
};
</script>

<template>
  <div class="form-guide-event-header">
    <FormGuideEventHeaderMobile
      v-if="isMobile"
      :event-data="eventData"
      :start-time="startTime"
      :event-name="eventName"
      :local-start="localStartTime"
      :is-resulted="isResulted"
      :is-imminent="isImminent"
      :is-ended="isEnded"
      class="mobile-class"
    />
    <FormGuideEventHeaderDesktop
      v-else
      :event-data="eventData"
      :start-time="startTime"
      :event-name="eventName"
      :local-start="localStartTime"
      :is-resulted="isResulted"
      :is-imminent="isImminent"
      :is-ended="isEnded"
      class="desktop-class"
    />
  </div>
</template>
